import algoliasearch from 'algoliasearch/lite'

import logger from '@logger'

export const concatResultHits = (results, { getWarrantyByProduct }) =>
  results
    .reduce((all, { hits }) => {
      return [...all, ...hits]
    }, [])
    .map((product) => ({
      ...product,
      warranty: getWarrantyByProduct(product),
    }))

export const findResultsFromMultipleQueries = async ({
  ALGOLIA_ID,
  ALGOLIA_KEY,
  queries,
}) => {
  const client = algoliasearch(ALGOLIA_ID, ALGOLIA_KEY)

  try {
    const { results } = await client.multipleQueries(queries)

    return results
  } catch (error) {
    logger.error('Algolia calls for CMS for multiple queries', { error })

    return []
  }
}

export const findResultsFromQuery = async ({
  ALGOLIA_ID,
  ALGOLIA_KEY,
  query,
}) => {
  const client = algoliasearch(ALGOLIA_ID, ALGOLIA_KEY)

  try {
    const { results } = await client.search([query])

    return results
  } catch (error) {
    logger.error('Algolia calls for CMS for single query', { error })

    return []
  }
}
